export default "__VITE_ASSET__0adpVxXB__"